import { FunctionComponent, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { ToggleExpandButton, RotationType } from '@cbridge-tools/button';
import { SectionSourceLink } from './SectionSourceLink/SectionSourceLink';
import { SECTION_ROOT_STYLES, SECTION_HEADER_STYLES } from './Section.constant';
import { ISectionProps } from './Section.interface';

export const Section: FunctionComponent<ISectionProps> = (props) => {
  const { title, link, linkSourceLabel, isCollapsedByDefault = false, children } = props;

  const [expanded, setExpanded] = useState(!isCollapsedByDefault);

  return (
    <Card sx={SECTION_ROOT_STYLES}>
      <CardActions disableSpacing={true} sx={SECTION_HEADER_STYLES}>
        <Typography variant={'overline'} sx={{
          marginRight: 'auto',
        }}>
          {title}
        </Typography>
        <SectionSourceLink href={link} name={linkSourceLabel} />
        <ToggleExpandButton
          isExpanded={expanded}
          onChange={setExpanded}
          rotationType={RotationType.Half}
          sx={{ marginLeft: 1 }}
        />
      </CardActions>
      <Collapse
        in={expanded}
        timeout={'auto'}
        unmountOnExit={true}
      >
        <CardContent component={Paper} elevation={0}>
          {children}
        </CardContent>
      </Collapse>
    </Card>
  );
};
